var map = {
	"./backtotop_icon.png": 3237,
	"./blurb-win.svg": 6708,
	"./btn-cross-white.svg": 6119,
	"./btn-cross.svg": 5762,
	"./candidates-placeholder.jpg": 9418,
	"./dropdown-arrow.svg": 8479,
	"./jigsaw.jpg": 2543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1041;